import { ProductType, type Website } from "../interfaces/websites";

export const LOCAL_HTML_DEMO_FUNNEL_ID = "local-html-funnel-replica";

const LOCAL_HTML_DEMO_PRODUCT_ID = "63aaca993e204c53ae9719f05ff17d8";
const LOCAL_HTML_DEMO_PRODUCT_IMAGE =
  "https://cdn.bemaster.com/mastershop/media/images/products/productImage-1712244603614.jpeg";

export const isLocalHtmlDemoEnabled = () =>
  import.meta.env.DEV && Boolean(import.meta.env.VITE_LOCAL_OWNER_ID);

export const isLocalHtmlDemoFunnel = (websiteId?: string | null) =>
  websiteId === LOCAL_HTML_DEMO_FUNNEL_ID;

export const getLocalHtmlDemoFunnelUrl = (animation = "pulse") => {
  const rawBuilderUrl = import.meta.env.VITE_REACT_APP_URL_BUILDER || "http://localhost:3000/";
  const builderUrl = rawBuilderUrl.includes("localhost")
    ? rawBuilderUrl
    : "http://localhost:3000/";

  return new URL(
    `/dev/html-funnel-replica?animation=${encodeURIComponent(animation)}`,
    builderUrl
  ).toString();
};

export const getLocalHtmlDemoFunnelEditorUrl = (userId: string, token?: string | null) => {
  const rawBuilderUrl = import.meta.env.VITE_REACT_APP_URL_BUILDER || "http://localhost:3000/";
  const builderUrl = rawBuilderUrl.includes("localhost")
    ? rawBuilderUrl
    : "http://localhost:3000/";
  const safeUserId = userId || import.meta.env.VITE_LOCAL_OWNER_ID || "local-demo-user";
  const url = new URL(`/builder/funnel/${safeUserId}/${LOCAL_HTML_DEMO_FUNNEL_ID}`, builderUrl);
  if (token) url.searchParams.set("token", token);
  return url.toString();
};

export const getLocalHtmlDemoWebsite = (userId: string): Website => ({
  userId,
  projectId: "",
  websiteId: LOCAL_HTML_DEMO_FUNNEL_ID,
  name: "SmartWatch, enfoque sin distracciones",
  productName: "SmartWatch Ultra 7",
  type: "FUNNEL",
  status: "Online",
  url: getLocalHtmlDemoFunnelUrl(),
  publicUrl: getLocalHtmlDemoFunnelUrl(),
  primaryPublicUrl: getLocalHtmlDemoFunnelUrl(),
  primaryHost: "localhost:3000",
  legacyOnlineslUrl: null,
  candidateUrls: [getLocalHtmlDemoFunnelUrl()],
  visits: 0,
  conversionRate: 0,
  salesSummary: null,
  theme: "HTML demo",
  lastEdited: new Date().toISOString(),
  createdAt: "2026-06-26T22:14:36.519Z",
  sales_angle: "Paz mental y diseño premium",
  sales_angle_description:
    "Embudo HTML de referencia para probar animaciones en botones reales de página.",
  sales_angle_complementary_angles: ["Botones HTML", "Animaciones", "CTA de checkout"],
  products: [
    {
      product_id: LOCAL_HTML_DEMO_PRODUCT_ID,
      productId: LOCAL_HTML_DEMO_PRODUCT_ID,
      id: LOCAL_HTML_DEMO_PRODUCT_ID,
      type: ProductType.PRINCIPAL,
    },
  ],
  productImage: LOCAL_HTML_DEMO_PRODUCT_IMAGE,
  generated: true,
  hasErrors: false,
  errorSections: [],
  generationStatus: "completed",
  failureStage: null,
  failureReason: null,
  failureCode: null,
  retryAvailable: false,
  recoveryAction: null,
  automaticOrderShopify: null,
  automaticOrderDropi: null,
  shopifyIntegrationStatus: null,
  dropiIntegrationStatus: null,
  configurations: {
    enabled: true,
    name_funnel: "SmartWatch HTML animado",
    __local_html_demo_funnel: true,
  },
  idSequence: 0,
  brand_name: "reloj",
});

export const withLocalHtmlDemoFunnel = (websites: Website[], userId: string) => {
  if (!isLocalHtmlDemoEnabled()) return websites;

  return [
    getLocalHtmlDemoWebsite(userId),
    ...websites.filter((website) => !isLocalHtmlDemoFunnel(website.websiteId)),
  ];
};
